import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import CurrentStatus from 'components/atoms/CurrentStatus';

const useStyles = makeStyles((theme) => ({
  contentsWrap: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    '& > div': { width: '100%', marginBottom: 5, boxSizing: 'border-box' },
    '&.two > div': { width: 'calc(50% - 10px)' },
    '&.three > div': { width: 'calc(33% - 10px)' },
    '&.four > div': { width: 'calc(25% - 10px)' },
    '&.drop > div': { minWidth: 200, maxWidth: 400 },
    '& h6': { fontSize: 16, margin: 0, fontWeight: 'lighter' },
  },
}));

/**
 * section을 갯수별로 나눠서 사용할 때 스타일을 별도로 지정하지 않고 contentsCount 값만으로 설정 가능 *최대 4개
 * @param props
 * @returns {*}
 * @constructor
 */
const ContentsWrap = (props) => {
  const classes = useStyles();
  const { contentsCount, loading = false, children } = props;

  return (
    <>
      {loading ? (
        <CurrentStatus type="loading" option="useMinHeight" />
      ) : (
        <div
          className={clsx(
            classes.contentsWrap,
            contentsCount === 2 && 'two',
            contentsCount === 3 && 'three',
            contentsCount === 4 && 'four',
            contentsCount === 0 && 'drop'
          )}
        >
          {children}
        </div>
      )}
    </>
  );
};

export default ContentsWrap;
